"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/styles");
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    teamMembersList: {
      margin: 0,
      padding: 0,
      display: 'flex',
      flexDirection: 'row-reverse',
      justifyContent: 'flex-end',
      listStyle: 'none',
      // pad-left most teamMembersListItem
      marginLeft: 10
    },
    teamMembersSharedDimensions: {
      height: 32,
      width: 32
    },
    teamMembersListItem: {
      // overlap each item
      marginLeft: -8,
      // display border
      boxSizing: 'content-box',
      position: 'relative',
      padding: 0,
      borderRadius: '100%',
      background: 'none',
      cursor: 'pointer',
      '&:focus': {
        outline: 'none'
      },
      borderWidth: 2,
      borderStyle: 'solid',
      borderColor: theme.palette.background.default
    },
    emailMembers: {
      color: theme.palette.NEUTRAL400,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: theme.typography.pxToRem(12),
      marginLeft: theme.spacing(0.5)
    },
    addTeamMembersListItem: {
      backgroundColor: theme.palette.NEUTRAL600,
      color: theme.palette.NEUTRAL000
    },
    addPeopleSvg: {
      fontSize: theme.typography.pxToRem(16),
      position: 'relative',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    },
    remainingMembers: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: theme.palette.NEUTRAL600,
      color: theme.palette.NEUTRAL000,
      fontSize: theme.typography.pxToRem(13)
    }
  };
});
var _default = useStyles;
exports.default = _default;